const jenkinsConfig = require('../../jenkins-config')
const { attachAsyncAppsFromManifest, getStagingVersionedUrl } = require('@gohighlevel/ghl-module-federation-plugin')
interface Config {
  voiceAiApp: string
  leadgenPaymentsApp: string
  paymentsApp: string
  reputationApp: string
  certificatesApp: string
  yextApp: string
  templateLibraryApp: string
  adPublishingApp: string
  reportingApp: string
  wordpressApp: string
  resellingApp: string
  affiliateDashboardApp: string
  agencyDashboardApp: string
  saasApp: string
  locationBillingApp: string
  companyApp: string
  locationsApp: string
  contentAIApp: string
  platformBillingApp: string
  agencyInternalToolsApp: string
  conversationsUtilitiesApp: string
  i18nFeedbackApp: string
  contactsHighriseApp: string
  conversationsApp: string
}

interface remoteConfigEnv {
  staging: Config
  interop: Config
  beta: Config
  production: Config
}

const remoteConfigEnv: remoteConfigEnv = {
  staging: {
    i18nFeedbackApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/i18n-feedback/remoteEntry.js?nocache=true',
    reputationApp: 'https://staging.appcdn.leadconnectorhq.com/revex/reputation/remoteEntry.js?nocache=true',
    yextApp: 'https://staging.appcdn.leadconnectorhq.com/revex/yext/remoteEntry.js?nocache=true',
    agencyDashboardApp: 'https://staging.appcdn.leadconnectorhq.com/revex/agency-dashboard/remoteEntry.js?nocache=true',
    voiceAiApp: 'https://staging.appcdn.leadconnectorhq.com/crm/voice-ai/remoteEntry.js?nocache=true',
    certificatesApp:
      'https://staging.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    templateLibraryApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/template-library/remoteEntry.js?nocache=true',
    adPublishingApp:
      'https://staging.appcdn.leadconnectorhq.com/automation-reporting/ad-publishing/remoteEntry.js?nocache=true',
    reportingApp:
      'https://staging.appcdn.leadconnectorhq.com/automation-reporting/reporting/remoteEntry.js?nocache=true',
    wordpressApp: 'https://staging.appcdn.leadconnectorhq.com/revex/wordpress/remoteEntry.js?nocache=true',
    resellingApp: 'https://staging.appcdn.leadconnectorhq.com/revex/reselling/remoteEntry.js?nocache=true',
    affiliateDashboardApp:
      'https://staging.appcdn.leadconnectorhq.com/revex/affiliate-portal/remoteEntry.js?nocache=true',
    saasApp: 'https://staging.appcdn.leadconnectorhq.com/revex/saas/remoteEntry.js?nocache=true',
    leadgenPaymentsApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/payments-widgets/remoteEntry.js?nocache=true',
    paymentsApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/ghl-payments/remoteEntry.js?nocache=true',
    locationBillingApp: 'https://staging.appcdn.leadconnectorhq.com/revex/location-billing/remoteEntry.js?nocache=true',
    companyApp: 'https://staging.appcdn.leadconnectorhq.com/revex/company/remoteEntry.js?nocache=true',
    locationsApp: 'https://staging.appcdn.leadconnectorhq.com/revex/locations/remoteEntry.js?nocache=true',
    contentAIApp: 'https://staging.appcdn.leadconnectorhq.com/crm/content-ai/remoteEntry.js?nocache=true',
    platformBillingApp: 'https://staging.appcdn.leadconnectorhq.com/revex/platform-billing/remoteEntry.js?nocache=true',
    agencyInternalToolsApp:
      'https://staging.appcdn.leadconnectorhq.com/revex/agency-internaltools/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://staging.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',
    contactsHighriseApp: 'https://staging.appcdn.leadconnectorhq.com/crm/contacts-highrise/remoteEntry.js?nocache=true',
    conversationsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/conversations-components/remoteEntry.js?nocache=true',
  },
  interop: {
    i18nFeedbackApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/i18n-feedback/remoteEntry.js?nocache=true',
    reputationApp: 'https://interop.appcdn.leadconnectorhq.com/revex/reputation/remoteEntry.js?nocache=true',
    yextApp: 'https://interop.appcdn.leadconnectorhq.com/revex/yext/remoteEntry.js?nocache=true',
    agencyDashboardApp: 'https://interop.appcdn.leadconnectorhq.com/revex/agency-dashboard/remoteEntry.js?nocache=true',
    voiceAiApp: 'https://interop.appcdn.leadconnectorhq.com/crm/voice-ai/remoteEntry.js?nocache=true',
    certificatesApp:
      'https://interop.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    templateLibraryApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/template-library/remoteEntry.js?nocache=true',
    adPublishingApp:
      'https://interop.appcdn.leadconnectorhq.com/automation-reporting/ad-publishing/remoteEntry.js?nocache=true',
    reportingApp:
      'https://interop.appcdn.leadconnectorhq.com/automation-reporting/reporting/remoteEntry.js?nocache=true',
    wordpressApp: 'https://interop.appcdn.leadconnectorhq.com/revex/wordpress/remoteEntry.js?nocache=true',
    resellingApp: 'https://interop.appcdn.leadconnectorhq.com/revex/reselling/remoteEntry.js?nocache=true',
    affiliateDashboardApp:
      'https://interop.appcdn.leadconnectorhq.com/revex/affiliate-portal/remoteEntry.js?nocache=true',
    saasApp: 'https://interop.appcdn.leadconnectorhq.com/revex/saas/remoteEntry.js?nocache=true',
    leadgenPaymentsApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/payments-widgets/remoteEntry.js?nocache=true',
    paymentsApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/ghl-payments/remoteEntry.js?nocache=true',
    locationBillingApp: 'https://interop.appcdn.leadconnectorhq.com/revex/location-billing/remoteEntry.js?nocache=true',
    companyApp: 'https://interop.appcdn.leadconnectorhq.com/revex/company/remoteEntry.js?nocache=true',
    locationsApp: 'https://interop.appcdn.leadconnectorhq.com/revex/locations/remoteEntry.js?nocache=true',
    contentAIApp: 'https://interop.appcdn.leadconnectorhq.com/crm/content-ai/remoteEntry.js?nocache=true',
    platformBillingApp: 'https://interop.appcdn.leadconnectorhq.com/revex/platform-billing/remoteEntry.js?nocache=true',
    agencyInternalToolsApp:
      'https://interop.appcdn.leadconnectorhq.com/revex/agency-internaltools/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://interop.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',

    contactsHighriseApp:'https://interop.appcdn.leadconnectorhq.com/crm/contacts-highrise/remoteEntry.js?nocache=true',
    conversationsApp: 'https://interop.appcdn.leadconnectorhq.com/crm/conversations-components/remoteEntry.js?nocache=true',

  },
  beta: {
    i18nFeedbackApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/i18n-feedback/remoteEntry.js?nocache=true',
    reputationApp: 'https://beta.appcdn.leadconnectorhq.com/revex/reputation/remoteEntry.js?nocache=true',
    yextApp: 'https://beta.appcdn.leadconnectorhq.com/revex/yext/remoteEntry.js?nocache=true',
    agencyDashboardApp: 'https://beta.appcdn.leadconnectorhq.com/revex/agency-dashboard/remoteEntry.js?nocache=true',
    voiceAiApp: 'https://beta.appcdn.leadconnectorhq.com/crm/voice-ai/remoteEntry.js?nocache=true',
    certificatesApp: 'https://beta.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    templateLibraryApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/template-library/remoteEntry.js?nocache=true',
    adPublishingApp:
      'https://beta.appcdn.leadconnectorhq.com/automation-reporting/ad-publishing/remoteEntry.js?nocache=true',
    reportingApp:
      'https://beta.appcdn.leadconnectorhq.com/automation-reporting/reporting/remoteEntry.js?nocache=true',
    wordpressApp: 'https://beta.appcdn.leadconnectorhq.com/revex/wordpress/remoteEntry.js?nocache=true',
    resellingApp: 'https://beta.appcdn.leadconnectorhq.com/revex/reselling/remoteEntry.js?nocache=true',
    affiliateDashboardApp: 'https://beta.appcdn.leadconnectorhq.com/revex/affiliate-portal/remoteEntry.js?nocache=true',
    saasApp: 'https://beta.appcdn.leadconnectorhq.com/revex/saas/remoteEntry.js?nocache=true',
    leadgenPaymentsApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/payments-widgets/remoteEntry.js?nocache=true',
    paymentsApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/ghl-payments/remoteEntry.js?nocache=true',
    locationBillingApp: 'https://beta.appcdn.leadconnectorhq.com/revex/location-billing/remoteEntry.js?nocache=true',
    companyApp: 'https://beta.appcdn.leadconnectorhq.com/revex/company/remoteEntry.js?nocache=true',
    locationsApp: 'https://beta.appcdn.leadconnectorhq.com/revex/locations/remoteEntry.js?nocache=true',
    contentAIApp: 'https://beta.appcdn.leadconnectorhq.com/crm/content-ai/remoteEntry.js?nocache=true',
    platformBillingApp: 'https://beta.appcdn.leadconnectorhq.com/revex/platform-billing/remoteEntry.js?nocache=true',
    agencyInternalToolsApp: 'https://beta.appcdn.leadconnectorhq.com/revex/agency-internaltools/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://beta.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',
    contactsHighriseApp: 'https://beta.appcdn.leadconnectorhq.com/crm/contacts-highrise/remoteEntry.js?nocache=true',
    conversationsApp: 'https://beta.appcdn.leadconnectorhq.com/crm/conversations-components/remoteEntry.js?nocache=true',
  },
  production: {
    i18nFeedbackApp: 'https://appcdn.leadconnectorhq.com/leadgen/i18n-feedback/remoteEntry.js?nocache=true',
    reputationApp: 'https://appcdn.leadconnectorhq.com/revex/reputation/remoteEntry.js?nocache=true',
    yextApp: 'https://appcdn.leadconnectorhq.com/revex/yext/remoteEntry.js?nocache=true',
    agencyDashboardApp: 'https://appcdn.leadconnectorhq.com/revex/agency-dashboard/remoteEntry.js?nocache=true',
    voiceAiApp: 'https://appcdn.leadconnectorhq.com/crm/voice-ai/remoteEntry.js?nocache=true',
    certificatesApp: 'https://appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    templateLibraryApp: 'https://appcdn.leadconnectorhq.com/leadgen/template-library/remoteEntry.js?nocache=true',
    adPublishingApp:
      'https://appcdn.leadconnectorhq.com/automation-reporting/ad-publishing/remoteEntry.js?nocache=true',
    reportingApp:
      'https://appcdn.leadconnectorhq.com/automation-reporting/reporting/remoteEntry.js?nocache=true',
    wordpressApp: 'https://appcdn.leadconnectorhq.com/revex/wordpress/remoteEntry.js?nocache=true',
    resellingApp: 'https://appcdn.leadconnectorhq.com/revex/reselling/remoteEntry.js?nocache=true',
    affiliateDashboardApp: 'https://appcdn.leadconnectorhq.com/revex/affiliate-portal/remoteEntry.js?nocache=true',
    saasApp: 'https://appcdn.leadconnectorhq.com/revex/saas/remoteEntry.js?nocache=true',
    leadgenPaymentsApp: 'https://appcdn.leadconnectorhq.com/leadgen/payments-widgets/remoteEntry.js?nocache=true',
    paymentsApp: 'https://appcdn.leadconnectorhq.com/leadgen/ghl-payments/remoteEntry.js?nocache=true',
    locationBillingApp: 'https://appcdn.leadconnectorhq.com/revex/location-billing/remoteEntry.js?nocache=true',
    companyApp: 'https://appcdn.leadconnectorhq.com/revex/company/remoteEntry.js?nocache=true',
    locationsApp: 'https://appcdn.leadconnectorhq.com/revex/locations/remoteEntry.js?nocache=true',
    contentAIApp: 'https://appcdn.leadconnectorhq.com/crm/content-ai/remoteEntry.js?nocache=true',
    platformBillingApp: 'https://appcdn.leadconnectorhq.com/revex/platform-billing/remoteEntry.js?nocache=true',
    agencyInternalToolsApp: 'https://appcdn.leadconnectorhq.com/revex/agency-internaltools/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',
    contactsHighriseApp: 'https://appcdn.leadconnectorhq.com/crm/contacts-highrise/remoteEntry.js?nocache=true',
    conversationsApp: 'https://appcdn.leadconnectorhq.com/crm/conversations-components/remoteEntry.js?nocache=true',
  },
}

let config =
  remoteConfigEnv[process.env.NODE_ENV === 'development' ? 'staging' : (process.env.NODE_ENV as keyof remoteConfigEnv)]

if (process.env.NODE_ENV === 'development') {
  // config.i18nFeedbackApp = 'http://localhost:3001/remoteEntry.js?nocache=true'
  // config.voiceAiApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
  // config.reputationApp = 'http://localhost:4002/remoteEntry.js?nocache=true'
  // config.yextApp = 'http://localhost:4003/remoteEntry.js?nocache=true'
  // config.certificatesApp = 'http://localhost:3004/remoteEntry.js?nocache=true'
  // config.templateLibraryApp = 'http://localhost:8083/remoteEntry.js?nocache=true'
  // config.adPublishingApp = 'http://localhost:3005/remoteEntry.js?nocache=true'
  // config.wordpressApp = 'http://localhost:4003/remoteEntry.js?nocache=true&app=wordpress'
  // config.affiliateDashboardApp = 'http://localhost:5002/remoteEntry.js?nocache=true'
  // config.leadgenPaymentsApp = 'http://localhost:3002/remoteEntry.js'
  // config.paymentsApp = 'http://localhost:3040/remoteEntry.js'
  // config.agencyDashboardApp = 'http://localhost:3051/remoteEntry.js'
  // config.saasApp = 'http://localhost:3051/remoteEntry.js'
  // config.locationBillingApp = 'http://localhost:4320/remoteEntry.js?nocache=true'
  // config.companyApp = 'http://localhost:5003/remoteEntry.js?nocache=true'
  // config.locationsApp = 'http://localhost:4320/remoteEntry.js?nocache=true'
  // config.contentAIApp = 'http://localhost:3003/remoteEntry.js?nocache=true'
  // config.platformBillingApp = 'http://localhost:4320/remoteEntry.js?nocache=true'
  // config.agencyInternalToolsApp = 'http://localhost:4322/remoteEntry.js?nocache=true'
  // config.conversationsUtilitiesApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
  // config.conversationsApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
}

if (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development') {
  const microApps = (jenkinsConfig.microApps && jenkinsConfig.microApps?.split(',')) || []
  const version = jenkinsConfig.version
  config = getStagingVersionedUrl(config, microApps, version)
}

if (process.env.NODE_ENV !== 'staging' && process.env.NODE_ENV !== 'development') {
  config = attachAsyncAppsFromManifest(config, process.env.NODE_ENV)
}

export default config
